import React from "react";
import "./TimelineSection.scss";

const steps = [
  {
    number: "1",
    title: "Orientation & inscription",
    description:
      "La femme se présente au centre ou contacte un assistant social, qui l'aide à remplir le formulaire d'orientation.",
  },
  {
    number: "2",
    title: "Création du dossier",
    description:
      "Un dossier unique est créé et partagé avec l'ensemble des associations du Maroc.",
  },
  {
    number: "3",
    title: "Sélection par une association",
    description:
      "L'association consulte les dossiers, filtre par région et spécialité, et sélectionne la candidate.",
  },
  {
    number: "4",
    title: "Suivi de la formation",
    description:
      "Le formateur documente la progression, la femme consulte ses notes et évaluations.",
  },
];

const TimelineSection = () => {
  return (
    <section className="timeline-section">
      <div className="container">

        <div className="timeline-title">
          <h2>Votre parcours, étape par étape</h2>
        </div>

        <div className="timeline">

          {steps.map((step, index) => (
            <div className="timeline-item" key={index}>

              <div className="timeline-circle">
                {step.number}
              </div>

              <h4>{step.title}</h4>

              <p>{step.description}</p>

            </div>
          ))}

        </div>

      </div>
    </section>
  );
};

export default TimelineSection;